import React, { Component } from 'react';
import { Form, Radio } from 'antd';
import { FormattedMessage  } from 'react-intl';
import { getReportType } from '../utils/utils';;

const layout = {
    labelCol: {
        span: 24,
    },
    wrapperCol: {       
        span: 24,
    },
};

class EmailReportTypeForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            report: this.getReportType(),
        };

        this.props.callbacks.setReportType(this.state.report);
    }

    getReportType()
    {
        var report_type = this.props.callbacks.getReportType();
        if (report_type !== undefined)
        {
            return report_type;
        } 
        
        return this.props.report.url === undefined ? "Report.Consumables" : getReportType(this.props.report.url)
    }

    onFieldsChange(changedFields, allFields)
    {
        if (typeof changedFields !== 'undefined' && changedFields.length > 0)
        {
            this.props.callbacks.setReportType(changedFields[0].value);
        }
    }
    
    onFinish(values) 
    {
        console.log(values);
    };
    
    onFinishFailed(errorInfo) 
    {
 
    };

    onChangeReport(e) {
        this.setState({
            report: e.target.value,
        });
      };

    render() {
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
            margin: '5px'
          };
    
        return (
            <div style={{align:"left", textAlign: "center"}}>
                <br/>
                <Form
                    {...layout}
                    name="basic"
                    initialValues={{
                        'radio-group': this.state.report,
                    }}
                    onFinish={(values) => this.onFinish(values)}
                    onSubmit={(values) => this.onFinish(values)}
                    onFinishFailed={(errorInfo) => this.onFinishFailed(errorInfo)}
                    onFieldsChange={(changedFields, allFields) => this.onFieldsChange(changedFields, allFields)}
                >
                <Form.Item name="radio-group">
                    <Radio.Group  buttonStyle="solid" size="middle" onChange={(e) => this.onChangeReport(e)}>
                        <Radio.Button style={radioStyle} value="Report.Consumables"><FormattedMessage id="Report.Consumables"/></Radio.Button>
                        <Radio.Button style={radioStyle} value="Report.Meters"><FormattedMessage id="Report.Meters"/></Radio.Button>
                        <Radio.Button style={radioStyle} value="Report.ChangeDeviceConsumables"><FormattedMessage id="Report.ChangeDeviceConsumables"/></Radio.Button>
                        <Radio.Button style={radioStyle} value="Report.ChangeDeviceStatus"><FormattedMessage id="Report.ChangeDeviceStatus"/></Radio.Button>
                        <Radio.Button style={radioStyle} value="Report.DocumentPrinted"><FormattedMessage id="Report.DocumentPrinted"/></Radio.Button>
                        <Radio.Button style={radioStyle} value="Report.PrintedJobs"><FormattedMessage id="Report.PrintedJobs"/></Radio.Button>
                        <Radio.Button style={radioStyle} value="Report.Summary"><FormattedMessage id="Report.Summary"/></Radio.Button>
                        <Radio.Button style={radioStyle} value="Report.Detailed"><FormattedMessage id="Report.Detailed"/></Radio.Button>
                    </Radio.Group>
                </Form.Item>
                </Form>
            </div>
        );
      }
}

export default EmailReportTypeForm;